import {ReactNode, useState} from 'react';
import * as css from './window.css';
import useShow from '../../../../hooks/useShow';
import useMobile from '../../../../hooks/useMobile';
import EventRolePermission from '../../../components/rolePermission/EventRolePermission';
import List from '../../../../component/list/List';
import {useTranslation} from 'react-i18next';
import {screen, hideEye} from '../../../../assets/symbols/symbols/Symbols.css';
import useRealtimeGrid, {windowsSettings} from '../../useRealtimeGrid';
import {LayoutIcon} from '../LayoutIcon/LayoutIcon';
import WindowFrame from '../windowFrame/WindowFrame';

export type WindowPropsType = {
    gridArea: string;
    link?: {onClick?: () => void, text: string, href?: string};
    explainComp?: ReactNode;
    howArrivedComp?: ReactNode;
    howArrivedTitle?: string;
    children?: ReactNode;
    role: any;
    height?: string;
    draggable?: boolean;
    deployable?: boolean;
}
export default function Window({deployable = true, draggable = true, gridArea, link = null, explainComp = null, howArrivedComp = null, howArrivedTitle, children = null, role, height = null}: WindowPropsType) {
    const isMobile = useMobile();
    const {open, close, isOpen, showClass} = useShow(500);
    const {t} = useTranslation('realtime');
    const {updateWindowSize, getShowWindow, showHideWin} = useRealtimeGrid();
    const showWindow = getShowWindow(gridArea);
    const [openLayout, setOpenLayout] = useState(false);

    const hideWindow = () => {
        showHideWin(gridArea, false);
    };
    const arrowIntoClick = () => {
        setOpenLayout(!openLayout);
    };
    const onLayoutClick = ({key}) => {
        updateWindowSize(gridArea, key);
    };
    const getOption = (size) => ({
        key: size,
        title: (size/12*100).toFixed()+ '%',
        rightChildren: <LayoutIcon percent={size/12*100} />,
        classes:'layoutItem', onClick:onLayoutClick, disabled: (windowsSettings[gridArea].minSize > size)
    });
    const moreWindowActions = [
        {key: 'hideWindow', text: t('hideWindow'), icon: hideEye, onClick:hideWindow},
        !isMobile && {key: 'changeDeployment', title: t('changeLayout'), icon: screen, list: [], classes: 'layoutParent'+(openLayout?' open':'')},
        ...(openLayout?[
            getOption(4),
            getOption(6),
            getOption(8),
            getOption(12)
        ]:[])
    ];

    const headerEnd = <>
        {deployable && <css.moreActionsIcon className="disabled" onClick={open} />}
        {isOpen && <List arrowIntoClick={arrowIntoClick} classes="free-color" close={()=>{close(); setOpenLayout(false);}} t={t} showClass={showClass} title={t('additionalActions')} list={moreWindowActions} top={5} left={'0'}/>}
    </>;

    return (
        showWindow && children ? <EventRolePermission { ...role} views={[]}>
            <WindowFrame gridArea={gridArea} height={height} className={(draggable?'draggable ':' ')+gridArea}
                header={{link, explainComp, howArrivedComp, howArrivedTitle, end: headerEnd, openLayout}}>
                {children}
            </WindowFrame>
        </EventRolePermission>
            :<></>
    );
}
